import React from 'react';
import { Modal } from '@solvhealth/jigsaw-v1';
import { NativeFunctions } from '~/core/util/native';
import { analyticsTrackEvent } from '~/core/analytics';

type Props = {
  ctaClickEvent: string;
  ctaClickHandler?: () => void;
  description?: string;
  isOpen: boolean;
  locationName: string;
  logo?: JSX.Element;
  onClose: () => void;
  redirectUrl?: string;
};

const LinkOutModal = (props: Props) => {
  const {
    ctaClickEvent,
    ctaClickHandler,
    description = 'Any information you provide will be subject to their privacy and security policies.',
    isOpen,
    locationName,
    logo,
    onClose,
    redirectUrl,
  } = props;
  const isLoading = !redirectUrl;

  const handleCtaClick = (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    ctaClickHandler?.();
    if (NativeFunctions.openNativeUrl.exists) {
      e.preventDefault();
      if (redirectUrl) {
        NativeFunctions.openNativeUrl.call(redirectUrl);
      }
    }
    onClose();
  };

  return (
    <Modal
      alignment="center"
      description={description}
      illustration={logo}
      onClose={onClose}
      open={isOpen}
      primaryCta={{
        text: 'Got it',
        href: redirectUrl,
        external: true,
        openInNewWindow: true,
        event: ctaClickEvent,
        loading: isLoading,
        disabled: isLoading,
        onClick: (
          e:
            | React.MouseEvent<HTMLButtonElement, MouseEvent>
            | React.MouseEvent<HTMLAnchorElement, MouseEvent>
        ) => {
          handleCtaClick(e);
        },
      }}
      title={`We're taking you to ${locationName}`}
      variant="short"
    />
  );
};

export default LinkOutModal;
